import React, {
  createContext,
  type Dispatch,
  type ReactNode,
  useContext,
  useState,
  type JSX,
} from 'react';

export type TableHiddenColumnsContext = {
  hiddenColumns: string[];
  setHiddenColumns: Dispatch<string[]>;
};

const defaultHiddenColumns = {
  hiddenColumns: [],
  setHiddenColumns: () => undefined,
};

export const TableHiddenColumnsContext =
  createContext<TableHiddenColumnsContext>(defaultHiddenColumns);

export const TableHiddenColumnsProvider = ({
  children,
  initialValue = [],
}: {
  children: ReactNode;
  initialValue?: string[];
}): JSX.Element => {
  const [hiddenColumns, setHiddenColumns] = useState<string[]>(initialValue);

  return (
    <TableHiddenColumnsContext.Provider
      value={{ hiddenColumns, setHiddenColumns }}
    >
      {children}
    </TableHiddenColumnsContext.Provider>
  );
};

const useTableHiddenColumns: () => TableHiddenColumnsContext = () =>
  useContext(TableHiddenColumnsContext) ?? defaultHiddenColumns;

export default useTableHiddenColumns;
